export const version = import.meta.env.VERSION;
export const userTokenStorageKey = 'APP_USER_TOKEN';
export const userBeneficiarioStorageKey = 'APP_USER_BENEFICIARIO';
export const userDependenteStorageKey = 'APP_USER_DEPENDENTE';
export const userOperadoraStorageKey = 'APP_USER_OPERADORA';
export const userPrestadorStorageKey = 'APP_USER_PRESTADOR';
export const userPrestadorAdministrativoStorageKey = 'APP_USER_PRESTADOR_ADMINISTRATIVO';
export const userOuvidoriaStorageKey = 'APP_USER_OUVIDORIA';
export const userAuditorStorageKey = 'APP_USER_AUDITOR';
export const userAdminStorageKey = 'APP_USER_ADMIN';
export const userPermissionsStorageKey = 'APP_USER_PERMISSIONS';
